/**
 * The contract asks for a UUID key. `crypto.randomUUID` is missing outside
 * secure contexts, so the fallback still produces a v4-shaped value rather than
 * an ad-hoc string the server would have to accept on trust.
 *
 * Every managed lead write that carries an `Idempotency-Key` mints it here: the
 * advancement update and the request values correction share one register on
 * the server, so they cannot disagree on what a key looks like.
 */
export const createManagedLeadIdempotencyKey = () => {
  const uuid = globalThis.crypto?.randomUUID?.();
  if (uuid) return uuid;

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
  });
};
